module.exports = [
  require('./pass_without_trace'),
  require('./plane_shift'),
  require('./poison_spray'),
  require('./prestidigitation'),
  require('./protection_from_evil_and_good'),
]
